import React, { useEffect, useState } from "react";
import date from "date-and-time";

const CurrentDateAndTime = () => {
  const [currentDate, setCurrentDate] = useState(new Date());

  // Update the current date every second (1000ms)
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000);

    // Clean up the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, []);

  // Format the current date
  const formattedDate = date.format(currentDate, "DD MMM , YYYY");
  const formattedTime = date.format(currentDate, "HH:mm:ss");

  return (
    <div className="hidden lg:block text-slate-300 font-sans -mt-1">
       <div className="flex items-center text-lg">
        <span>{formattedDate}</span>
        <div className="mx-3 h-6 w-px bg-black"></div>
        <span>{formattedTime}</span>
      </div>
    </div>
  );
};

export default CurrentDateAndTime;
